<div *ngIf="infoparcours && infoparcours[0] && infoparcours[0].applicationInformations">
  <div class="mb-6 p-5 rounded-xl border-l-4 border-blue-600 bg-blue-50 dark:bg-gray-800 shadow-md">

    <div class="flex items-center mb-3">
      <h2 class="text-lg font-bold text-blue-800 dark:text-blue-300 leading-none">
        Information
      </h2>
    </div>

    <p class="text-base text-gray-700 dark:text-gray-300 whitespace-pre-line leading-relaxed">
      {{infoparcours[0].applicationInformations}}
    </p>
  </div>
</div>